import { motion } from 'framer-motion';
import { AuroraBlobs, GrainOverlay, GlassChip, Reveal, fadeUp, stagger } from '../components/ui';

const SECTIONS = [
  { title: '1. Acceptance', body: 'By accessing or using VritiEthnic (vritiethnic.in), you agree to be bound by these Terms. If you do not agree, please do not use our platform.' },
  { title: '2. Eligibility', body: 'You must be at least 18 years of age to make purchases on VritiEthnic. By placing an order you confirm that you are legally capable of entering into binding contracts.' },
  { title: '3. Products & Pricing', body: 'All prices are in Indian Rupees (INR) and include applicable taxes. We reserve the right to modify prices without notice. Product images are representative; actual colours may vary due to screen calibration.' },
  { title: '4. Orders & Payment', body: 'An order is confirmed only after successful payment. We accept UPI, debit/credit cards via Razorpay, and Cash on Delivery (COD). COD orders are subject to availability by pin code.' },
  { title: '5. Shipping', body: 'Orders are typically dispatched within 2–3 business days. Estimated delivery is 5–7 business days. Free shipping on orders above ₹999. For orders below ₹999, a flat ₹60 shipping charge applies.' },
  { title: '6. Returns & Refunds', body: 'Please refer to our Returns Policy for complete details. Returns are accepted within 7 days of delivery for eligible items. Refunds are processed within 7–10 business days.' },
  { title: '7. Intellectual Property', body: 'All content on VritiEthnic including images, text, logos, and design is the property of VritiEthnic Fashion and may not be reproduced without written permission.' },
  { title: '8. Limitation of Liability', body: 'VritiEthnic\'s liability is limited to the value of the order placed. We are not responsible for delays caused by logistics partners, force majeure, or circumstances beyond our control.' },
  { title: '9. Governing Law', body: 'These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Jaipur, India.' },
  { title: '10. Contact', body: 'For queries regarding these Terms, contact us at legal@vritiethnic.in.' },
];

export default function TermsPage() { return <LegalPage chip="The fine print" title="Terms & Conditions" updated="June 2025" sections={SECTIONS} />; }

export function LegalPage({ chip, title, updated, sections, intro }) {
  return (
    <div>
      <section style={{ position: 'relative', background: '#1A100E', overflow: 'hidden', padding: '64px 24px 56px' }}>
        <AuroraBlobs muted />
        <GrainOverlay />
        <div style={{ position: 'relative', zIndex: 2, maxWidth: 760, margin: '0 auto' }}>
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <GlassChip>{chip}</GlassChip>
          </motion.div>
          <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }} className="serif" style={{ fontSize: 'clamp(36px, 4.6vw, 56px)', color: '#FFF', lineHeight: 1.05, letterSpacing: '-0.02em', marginTop: 18, marginBottom: 10 }}>
            {title}
          </motion.h1>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.25 }} style={{ fontSize: 12, color: 'rgba(237,227,209,0.5)', letterSpacing: '0.14em', textTransform: 'uppercase' }}>
            Last updated: {updated}
          </motion.div>
        </div>
      </section>

      <div style={{ maxWidth: 760, margin: '0 auto', padding: '40px 24px 64px' }}>
        {intro && (
          <Reveal>
            <p style={{ fontSize: 16, lineHeight: 1.8, color: 'var(--ink-2)', marginBottom: 32, fontStyle: 'italic' }}>{intro}</p>
          </Reveal>
        )}
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-40px' }} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {sections.map(s => (
            <motion.div key={s.title} variants={fadeUp} className="ve-glass-form-card" style={{ padding: '22px 26px' }}>
              <h2 className="serif" style={{ fontSize: 21, marginBottom: 10, color: 'var(--ink)', letterSpacing: '-0.01em' }}>{s.title}</h2>
              <p style={{ lineHeight: 1.8, color: 'var(--ink-2)', fontSize: 14 }}>{s.body}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
